import { createFileRoute } from '@tanstack/react-router';
import { AdminQuoteReviewPage } from '@/features/admin/admin-quote-review-page';

export const Route = createFileRoute('/gm/quotes/$id/')({
  component: GmQuoteReviewRoute,
});

function GmQuoteReviewRoute() {
  const { id } = Route.useParams();
  return <AdminQuoteReviewPage quoteId={id} backHref="/gm/quotes" portalBase="/gm" />;
}
